<script lang="ts" module>
	export const symbolId = "ishavskraft-icon-credit-card";
	export const symbol = `
		<symbol id="${symbolId}" viewBox="0 0 45 45">
			<path
				d="M30.0469 33.75C27.4219 33.75 25.1956 32.8437 23.3681 31.0312C21.5406 29.2187 20.6262 27 20.625 24.375C20.6238 21.75 21.5381 19.5312 23.3681 17.7187C25.1981 15.9062 27.4244 15 30.0469 15C32.6406 15 34.8437 15.9144 36.6562 17.7431C38.4687 19.5719 39.375 21.7825 39.375 24.375C39.375 26.9675 38.4687 29.1788 36.6562 31.0088C34.8437 32.8388 32.6406 33.7525 30.0469 33.75ZM3.75 26.25V11.25V11.8594V3.75V26.25ZM3.75 7.5H33.75V3.75H3.75V7.5ZM3.75 30C2.71875 30 1.83625 29.6331 1.1025 28.8994C0.36875 28.1656 0.00125 27.2825 0 26.25V3.75C0 2.71875 0.3675 1.83625 1.1025 1.1025C1.8375 0.36875 2.72 0.00125 3.75 0H33.75C34.7813 0 35.6644 0.3675 36.3994 1.1025C37.1344 1.8375 37.5012 2.72 37.5 3.75V11.1562C37.5 11.7187 37.2581 12.1331 36.7744 12.3994C36.2906 12.6656 35.7825 12.6731 35.25 12.4219C34.4375 12.0469 33.57 11.7575 32.6475 11.5537C31.725 11.35 30.78 11.2488 29.8125 11.25C28.0312 11.25 26.3519 11.5863 24.7744 12.2588C23.1969 12.9313 21.8138 13.845 20.625 15H3.75V26.25H16.0781C16.6094 26.25 17.055 26.43 17.415 26.79C17.775 27.15 17.9544 27.595 17.9531 28.125C17.9519 28.655 17.7725 29.1006 17.415 29.4619C17.0575 29.8231 16.6119 30.0025 16.0781 30H3.75ZM30.9375 24V19.6875C30.9375 19.4375 30.8438 19.2187 30.6563 19.0312C30.4688 18.8437 30.25 18.75 30 18.75C29.75 18.75 29.5312 18.8437 29.3437 19.0312C29.1562 19.2187 29.0625 19.4375 29.0625 19.6875V23.9531C29.0625 24.2031 29.1094 24.4456 29.2031 24.6806C29.2969 24.9156 29.4375 25.1263 29.625 25.3125L32.4844 28.1719C32.6719 28.3594 32.8906 28.4531 33.1406 28.4531C33.3906 28.4531 33.6094 28.3594 33.7969 28.1719C33.9844 27.9844 34.0781 27.7656 34.0781 27.5156C34.0781 27.2656 33.9844 27.0469 33.7969 26.8594L30.9375 24Z"
				fill="currentColor"
			/>
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		class: classes = null,
		ariaHidden = true,
	}: {
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

<svg
	aria-hidden={ariaHidden}
	width="24"
	height="24"
	viewBox="0 0 45 45"
	xmlns="http://www.w3.org/2000/svg"
	class={classes}
	fill="currentColor"
>
	<use href="#{symbolId}" />
</svg>
